import React from "react";

export default function Signal0({
  fill = "#e0e0e0",
  width = "40px",
  height = "40px",
  ...others
}) {
  return (
    <svg 
    width={width}
    height={height}
    viewBox="0 0 700 500" 
    {...others}>
     <g>
      <path d="m198.05 340.09c-4.9531 0.003906-8.9688 4.0195-8.9727 8.9727v69.07c0.003907 4.9531 4.0195 8.9688 8.9727 8.9727h55.266-0.003906c4.957-0.003906 8.9727-4.0195 8.9727-8.9727v-69.07c0-4.9531-4.0156-8.9688-8.9727-8.9727zm8.9922 17.965h37.297v51.105h-37.297z" fill={fill}/>
      <path d="m280.93 271.04c-4.9531 0.003906-8.9688 4.0195-8.9727 8.9766v138.12-0.003906c0.003907 4.9531 4.0195 8.9688 8.9727 8.9727h55.266c4.9531-0.003906 8.9688-4.0195 8.9727-8.9727v-138.12 0.003907c-0.003907-4.957-4.0195-8.9727-8.9727-8.9727zm8.9922 17.945h37.297v120.18h-37.297z" fill={fill}/>
      <path d="m363.8 201.97c-4.9531 0-8.9688 4.0156-8.9727 8.9727v207.19-0.003906c0.003907 4.9531 4.0195 8.9688 8.9727 8.9727h55.266c4.9531-0.003906 8.9688-4.0195 8.9727-8.9727v-207.19 0.003906c-0.003907-4.957-4.0195-8.9688-8.9727-8.9727zm8.9922 17.945h37.297v189.25l-37.293-0.003906z" fill={fill}/>
      <path d="m446.68 132.9c-4.957 0-8.9727 4.0156-8.9766 8.9727v276.26-0.003906c0.003907 4.9531 4.0195 8.9688 8.9766 8.9727h55.266-0.003907c4.9531-0.003906 8.9688-4.0195 8.9727-8.9727v-276.26 0.003906c-0.003907-4.957-4.0195-8.9727-8.9727-8.9727zm8.9922 17.965h37.297v258.29h-37.297z" fill={fill}/>
    </g>
    </svg>
  );
}
